import {
  Component,
  inject,
  input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  IpoLanguageService,
  IpoStringService,
  stringServiceFactory,
} from '@ip-only/front-end-library';
import { ReportViewTopComponent } from '../../../shared/self-inspection-reports/components/report-view-top.component';
import { RolloutProgressReportEntities } from '../../../shared/self-inspection-reports/service/entities';
import { InspectionReportInitService } from '../../../shared/self-inspection-reports/service/initial-values/inspection-report-init.service';
import en from '../../strings.en';
import fi from '../../strings.fi';
import sv from '../../strings.sv';

@Component({
  selector: 'app-rollout-progress-self-inspection-report-page',
  imports: [ReportViewTopComponent],
  providers: [
    {
      provide: IpoStringService,
      useFactory: stringServiceFactory({ en, sv, fi }),

      deps: [IpoLanguageService],
    },
  ],
  template: `@if (ifs(); as ifs) {
    @if (typeId(); as typeId) {
      @if (id(); as id) {
        <app-report-view-top [ifs]="ifs" [typeId]="typeId" [id]="id" />
      }
    }
  } `,
})
export class RolloutProgressInspectionReportPageComponent
  implements OnInit, OnChanges
{
  private readonly inspectionReportInitService = inject(
    InspectionReportInitService,
  );
  private readonly router = inject(Router);

  ifs = input<string>();
  typeId = input<RolloutProgressReportEntities.v3.MarkerTypes>();
  id = input<string>();

  ngOnInit(): void {
    this.setInitValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ifs'] && !changes['ifs'].firstChange) {
      this.redirectToRolloutMap();
    }
  }

  setInitValues = (): void => {
    const ifs = this.ifs();
    const typeId = this.typeId();
    const markerId = this.id();

    if (ifs && typeId && markerId) {
      this.inspectionReportInitService.setInspectionReportInitValues({
        ifs,
        typeId,
        markerId,
        urls: {
          answers:
            RolloutProgressReportEntities.v3.inspectionReportUrlTypes
              .spanProgress.answers,
          report:
            RolloutProgressReportEntities.v3.inspectionReportUrlTypes
              .spanProgress.report,
          reportGroups:
            RolloutProgressReportEntities.v3.inspectionReportUrlTypes
              .spanProgress.reportGroups,
          files:
            RolloutProgressReportEntities.v3.inspectionReportUrlTypes
              .spanProgress.files,
        },
      });
    } else {
      this.redirectToRolloutMap();
    }
  };

  redirectToRolloutMap = (): void => {
    this.router.navigate(['/rollout-progress']);
  };
}
